<template>
    <div v-if="hasGift" class="gift pa-4 mx-lg-0 mt-5 mx-6 text-center">
        <div class="gift-about">{{ $t('gift_course_title_') }} <div><span class="strong-red">{{ course.course }}!</span></div></div>
        <div class="gift-preview"><img :src="course.gift_cert" @click="gift" class=" pa-3"></div>
        <base-button @click="gift" class="gift-button mt-4 mb-3">{{ $t('buy_certificate') }}</base-button>
        <div class="gift-notice">{{ $t('buy_certificate_notice_') }} {{ course.course }}.</div>
    </div>
</template>

<script>
    export default {
        name: 'CourseGift',

        props: {
            course: Object
        },

        computed: {
            hasGift() {
                return this.course && this.course.gift_cert;
            }
        },

        methods: {
            gift() {
                this.$emit('gift')
                this.$router.push('/certificate/order/' + this.course.idcourse)
            },
        }
    }
</script>

<style scoped>

    .gift-notice {
        font-size: 13px;
        line-height: 15px;
    }

    .gift-about {
        font-family: Manrope Bold;
        font-size: 19px;
        line-height: 24px;
    }

    .gift-button  {
        background-color: #f15b22;
        border-color: #f15b22;
        text-shadow: 1px 1px #b93604;
        font-size: 18px;
    }

    .gift-preview {
        margin-top: 30px;
    }

    .gift-preview img {
        max-width: 80%;
        cursor: pointer;
    }

</style>
